import { useMemo } from 'preact/hooks';
import { Service, ServiceContent } from '@/base-api/types';
import { Button } from '@/components/button';
import { useOfferModal } from '@/hooks/useOfferModal'; // New hook import
import { formatCurrency } from '@/utils/number';

interface CartWidgetInnerInput {
  cartId: string;
  serviceContent: ServiceContent;
  service: Service;
  variantId: number;
}

export function CartWidgetInner(props: CartWidgetInnerInput) {
  const { openOfferModal } = useOfferModal(props);

  const { serviceContent, service } = props;
  const { offerings } = service;

  const lowestPrice = useMemo(() => {
    return offerings.reduce((min, { price }) => Math.min(min, price), Infinity);
  }, [offerings]);

  const buttonLabel = useMemo(() => {
    const buttonText =
      serviceContent.cart_cta.lead || 'Add accident protection from';
    return `${buttonText} ${formatCurrency(lowestPrice)}`;
  }, [serviceContent.cart_cta.lead, lowestPrice]);

  return (
    <div className="cart-widget-inner">
      <Button variant="primary" onClick={openOfferModal}>
        {buttonLabel}
      </Button>
    </div>
  );
}
